import {
  API_URL,
  store
} from '../index'
import axios from 'axios/index'

/* import error handler */
import ErrorHandler from '../ErrorHandler'
import SuccessHandler from '../SuccessHandler'
import _ from 'lodash'

/* private SupplierOrderProforma Types */
import {
  Settings,
  _SupplierOrderProforma
} from '../namespace-helper'

// selected item template
const selectedSupplierOrderProformaTemplate = {
  id: 0,
  suppliers_orders_proforma_status_id: 0,
  currencies_id: 0,
  vats_id: 0,
  documents_id: 0,
  total_price: '0.00',
  proforma_number: null,
  created_at: null
}

export default {
  namespaced: true,
  state: {
    supplierOrderProformas: [],
    selectedSupplierOrderProforma: _.cloneDeep(selectedSupplierOrderProformaTemplate)
  },
  mutations: {
    [_SupplierOrderProforma.mutations.setSupplierOrderProformas] (state, payload) {
      state.supplierOrderProformas = payload
    },
    [_SupplierOrderProforma.mutations.setSelectedSupplierOrderProforma] (state, payload) {
      if (payload !== null) {
        state.selectedSupplierOrderProforma = payload
      } else {
        state.selectedSupplierOrderProforma = _.cloneDeep(selectedSupplierOrderProformaTemplate)
      }
    },
    [_SupplierOrderProforma.mutations.setOpenCloseDialogState] (state) {
      state.openDialog = !state.openDialog
    }
  },
  actions: {
    [_SupplierOrderProforma.actions.saveSupplierOrderProforma] (context, payload) {
      store.commit(Settings.mutations.setLoading, true)

      const data = JSON.stringify(payload)
      return new Promise((resolve, reject) => {
        if (payload.id === 0) {
          var url = API_URL + '/api/v1/supplierOrderProformas'

          axios.post(url, data, {
            headers: {
              'Content-Type': 'application/json',
              Authorization: 'Bearer ' + store.getters.getBearerToken
            }
          }
          ).then(function (r) {
            store.commit(Settings.mutations.setLoading, false)
            ErrorHandler.clear(store)
            SuccessHandler.handleApiSuccess(store, r.data.message)
            context.commit(_SupplierOrderProforma.mutations.setSelectedSupplierOrderProforma, r.data.data)
            resolve(r)
          }, function (err) {
            ErrorHandler.handleApiError(store, err)
            reject(err)
          }).catch(e => console.error('#### ' + e))
        } else {
          url = API_URL + '/api/v1/supplierOrderProformas/' + payload.id

          axios.put(url, data, {
            headers: {
              'Content-Type': 'application/json',
              Authorization: 'Bearer ' + store.getters.getBearerToken
            }
          }
          ).then(function (r) {
            store.commit(Settings.mutations.setLoading, false)
            ErrorHandler.clear(store)
            SuccessHandler.handleApiSuccess(store, r.data.message)
            context.commit(_SupplierOrderProforma.mutations.setSelectedSupplierOrderProforma, r.data.data)
            resolve(r)
          }, function (err) {
            ErrorHandler.handleApiError(store, err)
            reject(err)
          }).catch(e => console.error('#### ' + e))
        }
      })
    },
    [_SupplierOrderProforma.actions.loadSupplierOrderProformas] (context, payload) {
      console.log('loadSupplierOrderProformas: ' + JSON.stringify(payload))
      console.log('loadSupplierOrderProformas: ' + payload.sortBy + ' ' + payload.descending + ' ' + payload.page + ' ' + payload.limit)

      var url = API_URL + '/api/v1/supplierOrderProformas?limit=' + payload.limit +
                '&page=' + payload.page +
                '&search=' + payload.search +
                '&searchFields=id:like;' +
                '&orderBy=' + payload.sortBy + '&sortedBy=' + payload.descending

      store.commit(Settings.mutations.setLoading, true)

      return axios.get(url, {
        headers: {
          'Content-Type': 'application/json',
          Authorization: 'Bearer ' + store.getters.getBearerToken
        }
      }
      ).then(function (r) {
        store.commit(Settings.mutations.setLoading, false)
        ErrorHandler.clear(store)
        console.log('loadedOffers: ' + JSON.stringify(r.data.data))
        context.commit(_SupplierOrderProforma.mutations.setSupplierOrderProformas, r.data.data)
      }, function (err) {
        ErrorHandler.handleApiError(store, err)
      }).catch(e => console.error('#### ' + e))
    },
    [_SupplierOrderProforma.actions.loadSupplierOrdersProforma] (context, payload) {
      console.log('loadSupplierOrdersProforma: ' + JSON.stringify(payload))

      var url = API_URL + '/api/v1/supplierOrderProformas/' + payload

      store.commit(Settings.mutations.setLoading, true)

      return axios.get(url, {
        headers: {
          'Content-Type': 'application/json',
          Authorization: 'Bearer ' + store.getters.getBearerToken
        }
      }
      ).then(function (r) {
        store.commit(Settings.mutations.setLoading, false)
        ErrorHandler.clear(store)
        console.log('loadSupplierOrdersProforma: ' + JSON.stringify(r.data.data))
        context.commit(_SupplierOrderProforma.mutations.setSelectedSupplierOrderProforma, r.data.data)
      }, function (err) {
        ErrorHandler.handleApiError(store, err)
      }).catch(e => console.error('#### ' + e))
    },
    [_SupplierOrderProforma.actions.setSelectedSupplierOrderProforma] ({ commit }, payload) {
      commit(_SupplierOrderProforma.mutations.setSelectedSupplierOrderProforma, payload)
    },
    [_SupplierOrderProforma.actions.loadStatuses] (context, payload) {
      store.commit(Settings.mutations.setLoading, true)

      return new Promise((resolve, reject) => {
        var url = API_URL + '/api/v1/supplierOrderProformaStatuses'

        axios.get(url, {
          headers: {
            'Content-Type': 'application/json',
            Authorization: 'Bearer ' + store.getters.getBearerToken
          }
        }
        ).then(function (r) {
          store.commit(Settings.mutations.setLoading, false)
          ErrorHandler.clear(store)
          resolve(r)
        }, function (err) {
          ErrorHandler.handleApiError(store, err)
          reject(err)
        }).catch(e => console.error('#### ' + e))
      })
    },
    [_SupplierOrderProforma.actions.deleteSupplierOrderProforma] (context, payload) {
      var url = API_URL + '/api/v1/supplierOrderProformas/' + payload.id

      store.commit(Settings.mutations.setLoading, true)

      return new Promise((resolve, reject) => {
        axios.delete(url, {
          headers: {
            'Content-Type': 'application/json',
            Authorization: 'Bearer ' + store.getters.getBearerToken
          }
        }
        ).then(function (r) {
          store.commit(Settings.mutations.setLoading, false)
          ErrorHandler.clear(store)
          SuccessHandler.handleApiSuccess(store, r.data.message)
          resolve(r)
        }, function (err) {
          store.commit(Settings.mutations.setLoading, false)
          ErrorHandler.handleApiError(store, err)
          reject(err)
        }).catch(e => console.error('#### ' + e))
      })
    },
    [_SupplierOrderProforma.actions.resetState] ({ commit }, payload) {
      commit(_SupplierOrderProforma.mutations.setSupplierOrderProformas, [])
      commit(_SupplierOrderProforma.mutations.setSelectedSupplierOrderProforma, null)
    }
  },
  getters: {
    [_SupplierOrderProforma.getters.supplierOrderProformas] (state) {
      return state.supplierOrderProformas
    },
    [_SupplierOrderProforma.getters.getSelectedSupplierOrderProforma] (state) {
      return state.selectedSupplierOrderProforma
    }

  }
}



// WEBPACK FOOTER //
// ./src/store/SupplierOrderProforma/supplierOrderProformas.js